import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export type Lang = 'zh' | 'en'

const LANG_KEY = 'musex_lang'

export const useLangStore = defineStore('lang', () => {
  const lang = ref<Lang>((localStorage.getItem(LANG_KEY) as Lang) || 'zh')

  watch(lang, (val) => {
    localStorage.setItem(LANG_KEY, val)
  })

  const setLang = (val: Lang) => {
    lang.value = val
  }

  return { lang, setLang }
})
